import { Schemas } from 'services/ArtboardConverter/models';

export const createScriptFormatting = ({
  sup = false,
  sub = false,
} = {} as Partial<Schemas.ScriptFormatting>): Schemas.ScriptFormatting => ({
  sup,
  sub,
});
